import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5 3H1C0.447715 3 0 3.44772 0 4C0 4.55228 0.447715 5 1 5H1.06445L1.87775 17.1996C1.98281 18.7755 3.29171 20 4.87111 20H13.1289C14.7083 20 16.0172 18.7754 16.1222 17.1996L16.9356 5H17C17.5523 5 18 4.55228 18 4C18 3.44772 17.5523 3 17 3H13C13 1.34315 11.6569 0 10 0H8C6.34315 0 5 1.34315 5 3ZM7 3C7 2.44772 7.44772 2 8 2H10C10.5523 2 11 2.44772 11 3H7ZM7 8C7.55228 8 8 8.44771 8 9V13C8 13.5523 7.55228 14 7 14C6.44771 14 6 13.5523 6 13V9C6 8.44771 6.44772 8 7 8ZM12 9C12 8.44771 11.5523 8 11 8C10.4477 8 10 8.44771 10 9V13C10 13.5523 10.4477 14 11 14C11.5523 14 12 13.5523 12 13V9Z",
  fill: "currentColor"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("svg", _hoisted_1, [
    _hoisted_2
  ]))
}